class AuctionAlgorithm {
    constructor(serverType) {
        this.serverType = serverType;
    }

    translate(t) {
        return t(`auctions.algorithm.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }
}

export const PRICE_RANDOM = new AuctionAlgorithm('PRICE_RANDOM');
export const PRICE_TIME = new AuctionAlgorithm('PRICE_TIME');

export const getAuctionAlgorithm = (serverType) => {
    let result = null;
    switch (serverType) {
        case 'PRICE_RANDOM':
            result = PRICE_RANDOM;
            break;
        case 'PRICE_TIME':
            result = PRICE_TIME;
            break;
        default:
            throw new Error(`Unknown auction algorithm: ${serverType}`);
    }
    return result;
};

export const getAllAuctionAlgorithms = () => [
    PRICE_RANDOM,
    PRICE_TIME,
];
